import Scrollbar from 'smooth-scrollbar';
import $ from 'jquery';

const customScroll = function customScroll() {
  const $win = $(window);
  let $winW = $win.width();
  const $home = $('.home');

  $win.on('resize', () => {
    $winW = $win.width();
  });

  const $fixed = $('.fixed');
  const options = {
    speed: 0.6,
    damping: 0.1,
    renderByPixels: true,
    syncCallbacks: true,
    continuousScrolling: true,
    overscrollEffect: false,
  };
  let $scroll;
  let $scrolled = 0;
  const $images = $('[data-src], [data-srcset]');
  if ($winW >= 768) {
    const scrollElem = document.getElementById('scrollbar');
    if (scrollElem) {
      Scrollbar.init(scrollElem, options);
    }

    const scrollingInner = Array.from(
      document.querySelectorAll('.product-details'),
    );

    if (scrollingInner) {
      scrollingInner.forEach(item => {
        Scrollbar.init(item, options);
      });
    }

    const scrollContent = document.getElementById('scrollbar-content');
    if (scrollContent) {
      $scroll = Scrollbar.init(scrollContent, options);

      const winH = $(window).height() / 2; // load images before in viewport

      if ($images && $images.length) {
        const firstImg = $($images[0]);
        if (firstImg) {
          if (firstImg[0].hasAttribute('data-src')) {
            firstImg.attr('src', firstImg.data('src'));
          }
          if (firstImg[0].hasAttribute('data-srcset')) {
            firstImg.attr('srcset', firstImg.data('srcset'));
          }
          firstImg.removeAttr('data-src data-srcset style width height');
          firstImg.addClass('show');
          $images.splice(0, 1);
        }
      }

      $scroll.addListener(ev => {
        $scrolled = ev.offset.y;
        $fixed.css('top', $scrolled);
        // lazy load
        if ($images.length) {
          $.each($images, (i, el) => {
            if (el) {
              const elTop = el.getBoundingClientRect();
              const top = Math.max($scrolled, elTop.top);
              const bottom = Math.min($scrolled + winH, elTop.bottom);

              if (top < bottom) {
                $images.splice(i, 1);
                const $self = $(el);
                if ($self[0].hasAttribute('data-src')) {
                  $self.attr('src', $self.data('src'));
                }
                if ($self[0].hasAttribute('data-srcset')) {
                  $self.attr('srcset', $self.data('srcset'));
                }
                $self.attr('src', $self.data('src'));
                $self.removeAttr('data-src data-srcset style width height');
                $self.on('load', () => {
                  $self.addClass('show');
                });
              }
            }
          });
        }

        // add class for homepage scrolled
        if ($home && $home.length) {
          if ($scrolled >= 100) {
            $home.addClass('scrolled');
          } else {
            $home.removeClass('scrolled');
          }
        }
      });
    }
  } else {
    $.each($images, (i, el) => {
      const $self = $(el);
      $self.attr('src', $self.data('src'));
      $self.removeAttr('style');
    });

    $win.on('scroll touchscroll', () => {
      if ($win.scrollTop() >= 80) {
        $home.addClass('scrolled');
      } else {
        $home.removeClass('scrolled');
      }
    });
  }
  // anchor scroll
  const anchors = $('[data-anchor]');
  const $header = $('.c-header');

  if (anchors.length) {
    anchors.click(ev => {
      ev.preventDefault();

      if ($winW >= 768) {
        const offsetTop =
          $(ev.target.hash).offset().top - $header.height() + $scrolled;

        $scroll.scrollTo(0, offsetTop, 800);
      } else {
        $('html, body').animate(
          {
            scrollTop: $(ev.target.hash).offset().top - 50,
          },
          500,
        );
      }
    });
  }
};
export default customScroll;



// WEBPACK FOOTER //
// ./src/scripts/modules/custom-scrollbar.js